
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 54 54","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(11 .295)"}},[_c('rect',{staticClass:"icon-stroke",attrs:{"x":"1","y":"1","width":"30","height":"51.41","rx":"15","fill":"none","stroke":"#fff","stroke-miterlimit":"10","stroke-width":"2"}}),_c('rect',{staticClass:"icon-fill",attrs:{"x":"13.08","y":"9.44","width":"5.84","height":"13.09","rx":"2.92","fill":"#fff"}})])])
          )
        }
      }
    